// extracted by mini-css-extract-plugin
export default {"illustration-info":"illustration-info--1n8Id","illustration-info__img":"illustration-info__img--2OrDl"};
    if(module.hot) {
      // 1747648148348
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  